import React from 'react';
import MotifButton from '@ey/motif-react-wrapper/Button';
import EllipseControl from '../EllipsesControl/EllipsesControl';
import MotifIcon from './MotifIcon';

export default function Button(props) {
	const {
		ariaLabel,
		id,
		className,
		labelClassName,
		variant,
		onClick,
		buttonLabel,
		disabled,
		stepper,
		title,
		type,
		showLabel,
		isEllipsed,
		noOfLines,
		showIcon,
		iconId,
		iconClassName,
		iconTitle,
		iconSource,
		iconFunction,
		children,
		size
	} = props;

	return (
		<MotifButton
			aria-label={ariaLabel}
			id={id}
			className={className}
			variant={variant}
			onClick={onClick}
			disabled={disabled}
			stepper={stepper}
			title={title}
			type={type}
			size={size}
		>
			{showIcon && (
				<MotifIcon
					id={iconId}
					className={iconClassName}
					title={iconTitle}
					src={iconSource}
					iconFunction={iconFunction}
				/>
			)}
			{showLabel &&
				(isEllipsed ? (
					<EllipseControl content={buttonLabel} tooltip={buttonLabel} noOfLines={noOfLines} />
				) : (
					<span className={labelClassName}>{buttonLabel}</span>
				))}
			{children}
		</MotifButton>
	);
}
